import { Button } from "@mui/material";
import { PlusMathIcon } from "Components/Shared/Icons";
import { Link } from "Navigation/Link";
import { getAppUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

export const OrderNewLicenseButton = () => {
  const appUrl = getAppUrl();
  const { t } = useResource();

  return (
    <Button
      component={Link}
      to={appUrl("orderLicense")}
      fullWidth
      color="primary"
      variant="contained"
      startIcon={<PlusMathIcon width={24} />}
    >
      {t(Resources.Pages.Content.LicenseDetail.OrderLicense)}
    </Button>
  );
};
